import classnames from 'classnames';
import { ReactComponent as HomeIcon } from 'img/iconButton/home.svg';
import { ReactComponent as LotteryIcon } from 'img/iconButton/lottery.svg';
import { ReactComponent as SportIcon } from 'img/iconButton/sport.svg';
import { ReactComponent as GameIcon } from 'img/iconButton/game.svg';
import { ReactComponent as SaleIcon } from 'img/iconButton/sale.svg';
import { ReactComponent as DownloadIcon } from 'img/iconButton/download.svg';

import './index.css';

export const iconType = {
  home: 'HOME',
  lottery: 'LOTTERY',
  sport: 'SPORT',
  game: 'GAME',
  sale: 'SALE',
  download: 'DOWNLOAD',
};

const icons = {
  [iconType.home]: <HomeIcon />,
  [iconType.lottery]: <LotteryIcon />,
  [iconType.sport]: <SportIcon />,
  [iconType.game]: <GameIcon />,
  [iconType.sale]: <SaleIcon />,
  [iconType.download]: <DownloadIcon />,
};

const IconButton = props => {
  const { children, icon, iconType, active, onClick } = props;

  const classNames = classnames('icon-btn-wrapper', {
    active: active,
    // highlight: highlight,
    // disabled: disabled,
  });

  const pic = icon ?? icons[iconType] ?? null;

  const handleClick = event => {
    onClick?.();
  };

  return (
    <div className={classNames} onClick={handleClick}>
      {pic}
      <span>{children}</span>
    </div>
  );
};

export default IconButton;
